export const shortcuts = [
  {
    id: 'a1ae91d3-e2cb-459b-9be9-a184694f548b',
    label: 'new-reservation',
    description: 'step-by-step',
    icon: 'heroicons_outline:calendar',
    link: '/reservations/steps',
    useRouter: true,
  },
  {
    id: 'a1ae91d3-e2cb-459b-9be9-a184694f548b',
    label: 'fast-reservation',
    description: '',
    icon: 'heroicons_outline:calendar',
    link: '/reservations/new',
    useRouter: true,
  },
  {
    id: '989ce876-c177-4d71-a749-1953c477f825',
    label: 'map',
    description: 'reservation-map',
    icon: 'heroicons_outline:map',
    link: '/reservation-map',
    useRouter: true,
  },
  {
    id: '989ce876-c177-4d71-a749-1953c477f825',
    label: 'reservation-map-type',
    description: 'reservation-map',
    icon: 'heroicons_outline:map',
    link: '/reservation-map-type',
    useRouter: true,
  },
  {
    id: '2496f42e-2f25-4e34-83d5-3ff9568fd984',
    label: 'person',
    description: 'person-record',
    icon: 'heroicons_outline:user-group',
    link: '/persons',
    useRouter: true,
  },
  {
    id: '3c48e75e-2ae7-4b73-938a-12dc655be28b',
    label: 'dashboard',
    description: 'statistics',
    icon: 'heroicons_outline:chart-pie',
    link: '/dashboard',
    useRouter: true,
  },
  // {
  //   id: '56a0a561-17e7-40b3-bd75-0b6cef230b7e',
  //   label: 'Financeiro',
  //   description: 'Dashboard',
  //   icon: 'mat_outline:payments',
  //   link: '/dashboard/finance',
  //   useRouter: true,
  // },
];
